import { useState } from "react";
import { subscribeNote } from "../../../mocks/starTracker";

export default function Subscribe() {
  const [status, setStatus] = useState<"idle" | "success" | "error">("idle");
  const [msg, setMsg] = useState("");

  const submit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const data = new FormData(form);
    const trap = (data.get("contact_alt") as string) || "";
    if (trap.trim()) {
      setStatus("success");
      setMsg("已收到你的订阅请求，感谢关注。");
      return;
    }
    data.delete("contact_alt");
    const payload = new URLSearchParams();
    data.forEach((v, k) => payload.append(k, v as string));
    try {
      const res = await fetch("https://readdy.ai/api/form/dagk5cjep053ijub2bs0", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: payload.toString(),
      });
      const responseText = await res.text();
      let parsed: any = null;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }
      const serverMsg =
        parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || "";
      if (res.ok && parsed?.code === "OK") {
        setStatus("success");
        setMsg("订阅成功！关键进展更新时会第一时间发到你的邮箱。");
        form.reset();
      } else {
        setStatus("error");
        setMsg(serverMsg || "提交失败，请稍后再试。");
      }
    } catch {
      setStatus("error");
      setMsg("网络异常，请稍后重试。");
    }
  };

  return (
    <section className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-[1200px] px-4 md:px-6 lg:px-10">
        <div className="relative overflow-hidden rounded-xl bg-foreground-950 px-6 py-10 md:px-12 md:py-14">
          <div className="pointer-events-none absolute -right-10 -top-10 h-60 w-60 rounded-full bg-primary-600/30 blur-3xl"></div>
          <div className="pointer-events-none absolute -bottom-14 left-1/4 h-52 w-52 rounded-full bg-accent-500/20 blur-3xl"></div>
          <div className="relative grid grid-cols-1 items-center gap-8 lg:grid-cols-2">
            <div>
              <span className="inline-flex items-center gap-1.5 text-sm font-semibold text-accent-300">
                <i className="ri-mail-send-line text-base"></i>
                关键节点简报
              </span>
              <h2 className="mt-3 font-heading text-2xl font-black leading-snug text-background-50 md:text-3xl">
                别守着热搜刷屏，<br className="hidden sm:block" />让关键进展自己来找你。
              </h2>
              <p className="mt-3 max-w-md text-sm leading-relaxed text-background-300/90">{subscribeNote}</p>
            </div>

            <div>
              {status === "success" ? (
                <div className="flex items-start gap-3 rounded-lg bg-accent-500/15 px-5 py-4 ring-1 ring-accent-400/40">
                  <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-md bg-accent-500 text-background-50">
                    <i className="ri-check-line text-lg"></i>
                  </span>
                  <p className="text-sm font-medium text-background-50">{msg}</p>
                </div>
              ) : (
                <form
                  data-readdy-form
                  onSubmit={submit}
                  className="rounded-lg bg-background-50/[0.06] p-5 ring-1 ring-background-50/15 backdrop-blur"
                >
                  <label htmlFor="email" className="text-xs font-semibold text-background-200">
                    你的邮箱
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    required
                    placeholder="name@example.com"
                    className="mt-2 w-full rounded-md border border-background-50/20 bg-background-50/10 px-4 py-3 text-sm text-background-50 placeholder:text-background-400/60 outline-none focus:border-accent-400"
                  />
                  <input
                    type="text"
                    name="contact_alt"
                    tabIndex={-1}
                    autoComplete="off"
                    aria-hidden="true"
                    readOnly
                    className="anti-bot-trap"
                  />
                  {status === "error" && (
                    <p className="mt-2 text-sm text-accent-300">{msg}</p>
                  )}
                  <button
                    type="submit"
                    className="mt-3 inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-600 px-5 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-500"
                  >
                    订阅关键进展 <i className="ri-arrow-right-line"></i>
                  </button>
                  <p className="mt-3 text-center text-[11px] text-background-400/70">
                    可随时退订。我们只发关键节点，不发轰炸邮件。
                  </p>
                </form>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}